<template>
	<div>
		<headerBox :current="6"></headerBox>
		<bannerBox ref="bannerChild"></bannerBox>
		<div class="content_box">
			<!-- <div class="common_search_box">
				<Input placeholder="请输入相关关键词">
				</Input>
				<div class="btn_box">
					<div>搜索</div>
					<div>重置</div>
				</div>
			</div> -->
			<div class="box3">
				<sp></sp>
				<ppt></ppt>
				<!-- <pdf></pdf> -->
				<wd></wd>
			</div>
		</div>
		<footerBox></footerBox>
		<Back-top :height="100" :bottom="200">
			<div class="iconfont icon-shangjiantou"></div>
		</Back-top>
	</div>
</template>

<script>
	import {
		swiper,
		swiperSlide
	} from "vue-awesome-swiper";
	import "swiper/dist/css/swiper.css";
	import bannerBox from '@/components/banner.vue'
	import headerBox from '@/components/header.vue'
	import footerBox from '@/components/footer.vue'
	import sp from './components/sp.vue'
	import ppt from './components/ppt.vue'
	import pdf from './components/pdf.vue'
	import wd from './components/wd.vue'
	import {
		getResourcese
	} from '@/api/home/guild'
	export default {
		name: 'home',
		components: {
			swiper,
			swiperSlide,
			bannerBox,
			headerBox,
			footerBox,
			sp,
			ppt,
			pdf,
			wd
		},
		data() {
			return {
				itemList: [{
						name: '全部资源',
						icon: 'icon-ziyuan-xianxing'
					},
					{
						name: '视频资料',
						icon: 'icon-shipintianchong'
					},
					{
						name: '课程ppt',
						icon: 'icon-_kecheng'
					},
					{
						name: '相关问答',
						icon: 'icon-datixitongguanli'
					}
				],
				newList: [],
				newListMore: [],
				swiperOption: {
					loop: true,
					speed: 1000,
					autoplay: false,
					allowTouchMove: false,
					autoplay: {
						delay: 3000,
						stopOnLastSlide: false,
						disableOnInteraction: false,
						pauseOnMouseEnter: true,
					},
					// 显示分页
					pagination: {
						el: ".swiper-pagination",
						clickable: true, //允许分页点击跳转
					},
					on: {
						click: function() {
							// const index = this.clickedSlide.dataset.swiperSlideIndex
							// that.goBannerUrl(index)
						}
					}
				},

			}
		},
		mounted() {
			this.$refs["bannerChild"].locationList = ['学习培训'];
		},
		methods: {
			playppt(it){
				window.open('http://view.officeapps.live.com/op/view.aspx?src='+it.resource)
			},
		}
	}
</script>

<style lang="scss" scoped>
	.content_box {
		padding: 30px 100px 80px;
		max-width: 1400px;
		min-width: 1100px;
		margin: auto;

		.box3 {
			margin-top: 20px;

			.swiper-container {
				position: relative;
				width: 100vm;

				.swiper-slide {
					width: 100%;
					color: #000;
				}

				img {
					object-fit: fill;
					height: 300px;
					width: 100%;
				}

				.swiper_text {
					padding: 0px 20px 40px;

					.title {
						font-size: 20px;
						margin: 10px 0;
					}
				}
			}

			/deep/ .swiper-pagination-bullet-active {
				background-color: #8971F1;
			}
			
		}
	}
</style>
